import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcCamcorderPro, FcFilmReel } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useSelector } from "react-redux";
import { socket } from "../../../api/socket.io";
import { Formik, Form } from "formik";

const ViewTaskDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);
  const store = useSelector((store) => store.login.user);
  const [schedules, setSchedules] = useState([]);

  console.log("store is", store);

  const getMessages = async () => {
    try {
      const res = await performRequest(
        "GET",
        `/mediaDelivery/get-task-messages/${id}`
      );

      if (res.status === 200) {
        setMessages(res.data?.data || []);
      }
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  useEffect(() => {
    const getTask = async () => {
      try {
        setLoading(true);

        const res = await performRequest(
          "GET",
          `/mediaDelivery/get-task/${id}`
        );

        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting task!");
        }
      } catch (err) {
        CustomErrorResponse(err);
      } finally {
        setLoading(false);
      }
    };

    getTask();
    getMessages();
  }, [id]);

  useEffect(() => {
    if (!id) return;

    const taskId = Number(id);

    socket.emit("joinMediaTask", {
      taskId,
    });

    console.log("Joined media task:", taskId);

    const handleNewMessage = (newMessage) => {
      console.log("🔥 NEW MESSAGE RECEIVED:", newMessage);

      setMessages((prev) => {
        const exists = prev.some(
          (item) => Number(item?.id) === Number(newMessage?.id)
        );

        if (exists) {
          return prev;
        }

        return [...prev, newMessage];
      });
    };

    socket.on("newMediaTaskMessage", handleNewMessage);

    return () => {
      socket.emit("leaveMediaTask", {
        taskId,
      });

      socket.off("newMediaTaskMessage", handleNewMessage);
    };
  }, [id, socket]);

  const handleApproveTask = async (values, { setSubmitting, resetForm }) => {
    try {
      setLoading(true);
      if (!values.scheduleGroupId) {
        Toast("error", "Please select a schedule");
        return;
      }

      if (!values.images?.length) {
        Toast("error", "Please select at least one Image/Video");
        return;
      }

      const res = await performRequest(
        "PATCH",
        `/postPlanning/update-latest-marketing-schedule`,
        {
          scheduleGroupId: values.scheduleGroupId,
          script: values.script,
          images: values.images,
        }
      );

      const updateTask = await performRequest(
        "PATCH",
        `/mediaDelivery/update-task-status/${id}`,
        {
          status: "approved",
        }
      );

      if (res.status === 200) {
        Toast("success", "Task approved successfully");

        const closeBtn = document.getElementById(
          "close-media-delivery-schedule"
        );

        if (closeBtn) {
          closeBtn.click();
        }

        setLoading(false);
        resetForm();
      }
    } catch (err) {
      CustomErrorResponse(err);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    const getSchedules = async () => {
      try {
        setLoading(true);

        const res = await performRequest(
          "GET",
          "/postPlanning/get-all-schedules"
        );

        if (res.status === 200) {
          setSchedules(res.data?.data || []);
        }
      } catch (error) {
        CustomErrorResponse(error);
      } finally {
        setLoading(false);
      }
    };

    getSchedules();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  //   const linkifyText = (text) => {
  //     if (!text) return "N/A";

  //     const urlRegex = /(https?:\/\/[^\s]+)/g;

  //     return text.split(urlRegex).map((part, index) => {
  //       if (part.match(urlRegex)) {
  //         return (
  //           <a key={index} href={part} target="_blank" rel="noopener noreferrer">
  //             {part}
  //           </a>
  //         );
  //       }
  //       return part;
  //     });
  //   };

  // const sendMessage = async () => {
  //   if (!message.trim()) {
  //     return;
  //   }

  //   try {
  //     setSendingMessage(true);

  //     const res = await performRequest(
  //       "POST",
  //       "/mediaDelivery/send-task-message",
  //       {
  //         taskId: id,
  //         message: message.trim(),
  //       }
  //     );

  //     if (res.status === 201 || res.status === 200) {
  //       setMessages((prev) => [...prev, res.data?.data]);

  //       setMessage("");
  //     }
  //   } catch (err) {
  //     CustomErrorResponse(err);
  //   } finally {
  //     setSendingMessage(false);
  //   }
  // };

  const sendMessage = () => {
    if (!message.trim()) {
      return;
    }

    setSendingMessage(true);

    socket.emit("sendMediaTaskMessage", {
      taskId: Number(id),
      message: message.trim(),

      userDetails: {
        id: store?.UserId,
        userName: store?.Name,
        role: store?.Role,
      },
    });

    setMessage("");
    setSendingMessage(false);
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCamcorderPro className="fs-2 me-1" />
                  Media Delivery
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Media Delivery</h2>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Task Name</label>
                    <div className="w-100 col">{data?.taskName || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Status</label>

                    <div className="w-100 col">
                      <span
                        className={
                          data?.status?.toLowerCase() === "assigned"
                            ? "badge bg-orange text-orange-fg"
                            : data?.status?.toLowerCase() === "approved"
                            ? "badge bg-green text-green-fg"
                            : data?.status?.toLowerCase() === "ready"
                            ? "badge bg-yellow text-yellow-fg"
                            : "fw-bold"
                        }
                      >
                        {data?.status || "N/A"}
                      </span>
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Brand Asset</label>
                    <div className="w-100 col">{data?.brandAsset || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Task Description{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.taskDescription || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Instructions{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.instructions || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Deadline </label>
                    <div className="w-100 col">{data?.deadline || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Created By Name
                    </label>
                    <div className="w-100 col">
                      {data?.createdByName || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reference Links
                    </label>

                    <div className="w-100 col">
                      {data?.links?.length > 0 ? (
                        <div className="d-flex flex-column gap-2">
                          {data.links.map((link, index) => (
                            <div key={index}>
                              <a
                                href={link?.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {link?.url}
                              </a>
                            </div>
                          ))}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Raw Videos</label>

                    <div className="w-100 col">
                      {data?.rawVideos?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "15px",
                          }}
                        >
                          {data.rawVideos.map((video, index) => (
                            <div key={index}>
                              <video
                                src={video?.url}
                                controls
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Raw Photos</label>

                    <div className="w-100 col">
                      {data?.rawImages?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "15px",
                          }}
                        >
                          {data.rawImages.map((image, index) => (
                            <div key={index}>
                              <img
                                src={image?.url}
                                alt={image?.fileName || `Photo ${index + 1}`}
                                style={{
                                  width: "150px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                  <hr></hr>
                  <h3>Final Work</h3>
                  <hr></hr>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Submitted Work
                    </label>

                    <div className="w-100 col">
                      {data?.submittedWork?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "15px",
                          }}
                        >
                          {data.submittedWork.map((url, index) => {
                            const isVideo = /\.(mp4|mov|avi|webm|mkv)$/i.test(
                              url
                            );

                            return (
                              <div key={index}>
                                {isVideo ? (
                                  <video
                                    src={url}
                                    controls
                                    style={{
                                      width: "500px",
                                      height: "500px",
                                      objectFit: "cover",
                                      borderRadius: "5px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={url}
                                    alt={`Submitted Work ${index + 1}`}
                                    style={{
                                      width: "500px",
                                      height: "500px",
                                      objectFit: "cover",
                                      borderRadius: "5px",
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>

                  <div className="card mt-4">
                    <div className="card-header">
                      <h3 className="card-title">Communication with Agency</h3>
                    </div>

                    <div className="card-body">
                      {/* MESSAGES */}
                      <div
                        className="border rounded p-3 mb-3"
                        style={{
                          height: "400px",
                          overflowY: "auto",
                          backgroundColor: "#f5f6f8",
                        }}
                      >
                        {messages?.length > 0 ? (
                          messages.map((item, index) => {
                            // Current logged-in user's message
                            const isMine =
                              Number(item?.senderId) === Number(store?.UserId);

                            return (
                              <div
                                key={item?.id || index}
                                className={`d-flex mb-3 ${
                                  isMine
                                    ? "justify-content-end"
                                    : "justify-content-start"
                                }`}
                              >
                                <div
                                  style={{
                                    maxWidth: "70%",
                                  }}
                                >
                                  {/* SENDER NAME */}
                                  <div
                                    className={`small text-muted mb-1 ${
                                      isMine ? "text-end" : "text-start"
                                    }`}
                                  >
                                    {item?.senderName || "User"}
                                  </div>

                                  {/* MESSAGE */}
                                  <div
                                    className="p-2 px-3"
                                    style={{
                                      backgroundColor: isMine
                                        ? "#206bc4"
                                        : "#ffffff",

                                      color: isMine ? "#ffffff" : "#212529",

                                      border: isMine
                                        ? "none"
                                        : "1px solid #e6e7e9",

                                      borderRadius: isMine
                                        ? "12px 12px 0px 12px"
                                        : "12px 12px 12px 0px",

                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {item?.message}
                                  </div>

                                  {/* TIME */}
                                  <div
                                    className={`small text-muted mt-1 ${
                                      isMine ? "text-end" : "text-start"
                                    }`}
                                  >
                                    {item?.createdAt
                                      ? new Date(
                                          item.createdAt
                                        ).toLocaleString()
                                      : ""}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="text-center text-muted py-5">
                            No messages yet.
                          </div>
                        )}
                      </div>

                      {/* MESSAGE INPUT */}
                      <div className="d-flex gap-2">
                        <input
                          type="text"
                          className="form-control"
                          value={message}
                          placeholder="Type your message..."
                          onChange={(e) => setMessage(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();

                              if (!sendingMessage && message.trim()) {
                                sendMessage();
                              }
                            }
                          }}
                        />

                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={sendingMessage || !message.trim()}
                          onClick={sendMessage}
                        >
                          {sendingMessage ? "Sending..." : "Send"}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      {store?.Role !==
                        process.env.REACT_APP_ROLE_MARKETING_AGENCY && (
                        <button
                          type="button"
                          className="btn mx-1 mt-2 btn-success"
                          data-bs-toggle="modal"
                          data-bs-target="#approveMediaTaskModal"
                        >
                          APPROVED
                        </button>
                      )}

                      <SimpleButton
                        buttonText="Edit Media Dievery Task Info"
                        href={`/media-task-update/${id}`}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                  <div
                    className="modal modal-blur fade"
                    id="approveMediaTaskModal"
                    tabIndex="-1"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                      <div className="modal-content">
                        <Formik
                          initialValues={{
                            scheduleGroupId: "",
                            script: "",
                            images: data?.submittedWork || [],
                          }}
                          onSubmit={handleApproveTask}
                        >
                          {({ values, setFieldValue, isSubmitting }) => (
                            <Form>
                              {/* HEADER */}

                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Approve Media Delivery
                                </h5>

                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                  id="close-media-delivery-schedule"
                                />
                              </div>

                              {/* BODY */}

                              <div className="modal-body">
                                {/* SCHEDULE */}

                                <div className="mb-3">
                                  <label className="form-label">
                                    Select Schedule
                                  </label>

                                  <select
                                    className="form-select"
                                    name="scheduleGroupId"
                                    value={values.scheduleGroupId}
                                    onChange={(e) =>
                                      setFieldValue(
                                        "scheduleGroupId",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="">Select Schedule</option>

                                    {schedules?.map((schedule) => (
                                      <option
                                        key={schedule.scheduleGroupId}
                                        value={schedule.scheduleGroupId}
                                      >
                                        {schedule.scheduleGroupId} -{" "}
                                        {schedule.scheduleName || "Schedule"}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* SCRIPT */}

                                <div className="mb-3">
                                  <label className="form-label">Script</label>

                                  <textarea
                                    className="form-control"
                                    name="script"
                                    rows="5"
                                    placeholder="Enter script..."
                                    value={values.script}
                                    onChange={(e) =>
                                      setFieldValue("script", e.target.value)
                                    }
                                  />
                                </div>

                                {/* IMAGE */}

                                <div className="row g-3">
                                  {data?.submittedWork?.map((item, index) => {
                                    const selected =
                                      values.images?.includes(item);

                                    const fileUrl = item
                                      ?.split("?")[0]
                                      ?.toLowerCase();

                                    const isVideo =
                                      fileUrl?.endsWith(".mp4") ||
                                      fileUrl?.endsWith(".mov") ||
                                      fileUrl?.endsWith(".webm") ||
                                      fileUrl?.endsWith(".m4v") ||
                                      fileUrl?.endsWith(".avi");

                                    return (
                                      <div className="col-md-4" key={index}>
                                        <div
                                          className={`card h-100 ${
                                            selected ? "border-success" : ""
                                          }`}
                                        >
                                          {/* IMAGE / VIDEO */}
                                          {isVideo ? (
                                            <video
                                              src={item}
                                              controls
                                              style={{
                                                width: "100%",
                                                height: "150px",
                                                objectFit: "cover",
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src={item}
                                              alt={`Image ${index + 1}`}
                                              style={{
                                                width: "100%",
                                                height: "150px",
                                                objectFit: "cover",
                                              }}
                                            />
                                          )}

                                          {/* CHECKBOX */}
                                          <div className="card-body p-2">
                                            <label className="form-check">
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={selected}
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setFieldValue("images", [
                                                      ...(values.images || []),
                                                      item,
                                                    ]);
                                                  } else {
                                                    setFieldValue(
                                                      "images",
                                                      (
                                                        values.images || []
                                                      ).filter(
                                                        (url) => url !== item
                                                      )
                                                    );
                                                  }
                                                }}
                                              />

                                              <span className="form-check-label">
                                                Select{" "}
                                                {isVideo ? "Video" : "Image"}
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              {/* FOOTER */}

                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Cancel
                                </button>

                                <button
                                  type="submit"
                                  className="btn btn-success"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting
                                    ? "Approving..."
                                    : "Approve & Schedule"}
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewTaskDetails;
